import React from "react";

const SPORT_COLORS = {
  NBA: "#FF4500",
  NFL: "#00E5FF",
  NHL: "#FACC15",
  MLB: "#A78BFA",
};

export function PlayerAvatar({ player, size = 48 }) {
  const initials = (player?.initials || (player?.name?.split(" ").map((s) => s[0]).slice(0, 2).join("") || "??")).toUpperCase();
  const color = SPORT_COLORS[player?.sport] || "#FF4500";
  return (
    <div
      className="flex items-center justify-center font-head font-semibold"
      style={{
        width: size,
        height: size,
        background: "#0A0A0A",
        color,
        border: `1px solid ${color}`,
        letterSpacing: "0.02em",
        fontSize: size * 0.42,
      }}
      data-testid="player-avatar"
    >
      {initials}
    </div>
  );
}
